export const BLOCKS_TYPES = Object.freeze({
  VIDEO_PRODUCTS: 'video_products',
  CATALOG: 'catalog',
  ARTICLES: 'articles',
  YOUTUBE: 'youtube',
  TEXT: 'text',
  IMAGE: 'image',
  TOP_CATEGORIES: 'top_categories',
  OUR_FEATURES: 'our_features',
  PRODUCT_OF_THE_DAY: 'product_of_the_day',
  CATEGORIES_WITH_PRODUCTS: 'categories_with_products_and_images',
  COUNTERS: 'counter'
})

export const PRODUCTS_BLOCKS_TYPES = Object.freeze({
  FIXED: 'fixed',
  NOVELTY: 'novelty',
  SALE: 'sale',
  ESPUTNIK_RECOMENDATION: 'esputnik_recommendation',
  VIEWED_PRODUCTS: 'viewed_products'
})

export const ESPUTNIK_BLOCK_CONTEXT = Object.freeze({
  CONTEXT_PRODUCT: 'product',
  CONTEXT_CATEGORY: 'category',
  CONTEXT_CART: 'cart',
  CONTEXT_NO_CONTEXT: 'no_context'
})
